module.exports = __webpack_public_path__ + "dashboard/img/group.6a045a03383ad8d883eabb8e2f70a1d0.svg";